/* Product cards: the second (hover) image is rendered inside a <template>
   so the browser does not fetch it. On the first pointer hover over a card
   the image is inserted and loads. Delegated, so cards added later (search,
   recommendations, saved page) work too. Touch devices never hover, so they
   never download the extra image. */
(function () {
  function reveal(card) {
    var template = card.querySelector('[data-hover-image]');
    if (!template) return;
    var media = template.parentNode;
    media.appendChild(template.content.cloneNode(true));
    template.remove();
  }

  /* Mobile image strip: the extra slides are inserted on the first touch,
     before the swipe starts, so nothing is downloaded until the visitor
     actually swipes. Desktop never touches the strip. */
  function revealSlides(strip) {
    var template = strip.querySelector('[data-card-rest]');
    if (!template) return;
    strip.appendChild(template.content.cloneNode(true));
    template.remove();
  }

  document.addEventListener(
    'touchstart',
    function (event) {
      var strip = event.target.closest && event.target.closest('[data-card-slides]');
      if (strip) revealSlides(strip);
    },
    { capture: true, passive: true }
  );

  /* Mobile image strip: move the progress line with the scroll position. */
  document.addEventListener(
    'scroll',
    function (event) {
      var strip = event.target;
      if (!strip || !strip.hasAttribute || !strip.hasAttribute('data-card-slides')) return;
      var max = strip.scrollWidth - strip.clientWidth;
      var progress = max > 0 ? strip.scrollLeft / max : 0;
      strip.parentNode.style.setProperty('--card-progress', String(Math.min(1, Math.max(0, progress))));
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    'pointerover',
    function (event) {
      if (event.pointerType === 'touch') return;
      var card = event.target.closest && event.target.closest('.product-card');
      if (card) reveal(card);
    },
    { passive: true }
  );
})();
